// Generated by ReScript, PLEASE EDIT WITH CARE
'use strict';

let IconV5 = require("../../uikit/atoms/Icon/IconV5.bs.js");
let ButtonsV5 = require("../../uikit/reason/atoms/Buttons/ButtonsV5.bs.js");
let Primitive_option = require("@rescript/runtime/lib/js/Primitive_option.js");
let JsxRuntime = require("react/jsx-runtime");
let FragmentErrorBoundary = require("../common/ErrorHandling/FragmentErrorBoundary.bs.js");
let RescriptRelay_Fragment = require("rescript-relay/src/RescriptRelay_Fragment.bs.js");
let ClientStatsWidget_query_graphql = require("../../__generated__/ClientStatsWidget_query_graphql.bs.js");

let convertFragment = ClientStatsWidget_query_graphql.Internal.convertFragment;

function waitForFragmentData(environment, fRef) {
  return RescriptRelay_Fragment.waitForFragmentData(environment, ClientStatsWidget_query_graphql.node, convertFragment, fRef);
}

function use(fRef) {
  return RescriptRelay_Fragment.useFragment(ClientStatsWidget_query_graphql.node, convertFragment, fRef);
}

function useOpt(fRef) {
  return RescriptRelay_Fragment.useFragmentOpt(fRef !== undefined ? Primitive_option.some(Primitive_option.valFromOption(fRef)) : undefined, ClientStatsWidget_query_graphql.node, convertFragment);
}

function readResolverFragment(fRef) {
  return RescriptRelay_Fragment.read(ClientStatsWidget_query_graphql.node, convertFragment, fRef);
}

let Fragment = {
  Types: undefined,
  Operation: undefined,
  convertFragment: convertFragment,
  waitForFragmentData: waitForFragmentData,
  use: use,
  useOpt: useOpt,
  readResolverFragment: readResolverFragment
};

function noun(clientsType) {
  if (clientsType === "Sellers") {
    return "seller";
  } else {
    return "buyer";
  }
}

function pluralNoun(clientsType) {
  if (clientsType === "Sellers") {
    return "sellers";
  } else {
    return "buyers";
  }
}

function url(clientsType) {
  if (clientsType === "Sellers") {
    return "/sellers/new";
  } else {
    return "/private_buyers/new";
  }
}

function ClientStatsWidget$ClientsCount(props) {
  let count = props.count;
  let clientsType = props.clientsType;
  let noun$1 = noun(clientsType);
  let pluralNoun$1 = pluralNoun(clientsType);
  let url$1 = url(clientsType);
  if (count === 0) {
    return JsxRuntime.jsxs("span", {
      children: [
        `You have no active ` + pluralNoun$1 + `. `,
        JsxRuntime.jsx(ButtonsV5.Link.make, {
          href: url$1,
          children: `Add your ` + noun$1 + ` to get matches`
        })
      ]
    });
  }
  if (count >= 3) {
    return JsxRuntime.jsx("span", {
      children: `You have ` + count.toString() + ` active ` + pluralNoun$1 + `.`
    });
  }
  let activeNounForm = count === 1 ? noun$1 : pluralNoun$1;
  return JsxRuntime.jsxs("span", {
    children: [
      `You have ` + count.toString() + ` active ` + activeNounForm + `. `,
      JsxRuntime.jsx(ButtonsV5.Link.make, {
        href: url$1,
        children: `Add more ` + pluralNoun$1 + ` to get more matches`
      })
    ]
  });
}

let ClientsCount = {
  noun: noun,
  pluralNoun: pluralNoun,
  url: url,
  make: ClientStatsWidget$ClientsCount
};

function ClientStatsWidget$WithoutErrorBoundary(props) {
  let match = RescriptRelay_Fragment.useFragment(ClientStatsWidget_query_graphql.node, convertFragment, props.query);
  let match$1 = match.clientStatsForCurrentAccountV5;
  return JsxRuntime.jsxs("div", {
    children: [
      JsxRuntime.jsx("h3", {
        children: "My Clients",
        className: "mb-4 font-medium text-3xl text-gray-800"
      }),
      JsxRuntime.jsxs("div", {
        children: [
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "home",
                size: 30,
                className: "text-tan-blue-500"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ClientStatsWidget$ClientsCount, {
                  clientsType: "Sellers",
                  count: match$1.sellers
                }),
                className: "pl-4"
              })
            ],
            className: "flex items-center py-4"
          }),
          JsxRuntime.jsxs("div", {
            children: [
              JsxRuntime.jsx(IconV5.make, {
                icon: "people",
                size: 30,
                className: "text-tan-blue-500"
              }),
              JsxRuntime.jsx("div", {
                children: JsxRuntime.jsx(ClientStatsWidget$ClientsCount, {
                  clientsType: "Buyers",
                  count: match$1.buyers
                }),
                className: "pl-4"
              })
            ],
            className: "flex items-center py-4"
          })
        ]
      })
    ]
  });
}

let WithoutErrorBoundary = {
  make: ClientStatsWidget$WithoutErrorBoundary
};

function ClientStatsWidget(props) {
  return JsxRuntime.jsx(FragmentErrorBoundary.make, {
    fragmentDisplayName: "client stats",
    children: JsxRuntime.jsx(ClientStatsWidget$WithoutErrorBoundary, {
      query: props.query
    })
  });
}

let make = ClientStatsWidget;

exports.Fragment = Fragment;
exports.ClientsCount = ClientsCount;
exports.WithoutErrorBoundary = WithoutErrorBoundary;
exports.make = make;
/* IconV5 Not a pure module */
